import React, { Component } from "react";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";

//components
import Aux from "../hocs/Auxiliary";
import LogoDark from "../Assets/Pngs/LogoDark1.png";
import Game from "./Game/Game";

import ttt from "../Assets/Images/tictactoe.png";
import DAB from "../Assets/Images/DAB.png";
import Snake from "../Assets/Images/Snake.png";
import TZFE from "../Assets/Images/2048.png";
import uttt from "../Assets/Images/uttt.png";
import sim from "../Assets/Images/sim.png";

//classes
import classes from "./Home.css";
import Footer from "../Extras/Footer/Footer";

class Home extends Component {
  state = {
    scrolled: false,
    width: window.innerWidth,
    height: window.innerHeight,
    modifierValue:
      window.innerWidth < 700
        ? window.innerWidth * 0.22
        : window.innerWidth * 0.15,
  };

  scrollHandler = (e) => {
    // console.log(window.scrollY)
    if (window.scrollY > 10) {
      this.setState({
        scrolled: true,
      });
    } else {
      this.setState({
        scrolled: false,
      });
    }
  };

  resizeHandler = () => {
    let newModifier = window.innerWidth * 0.15;
    if (window.innerWidth < 700) {
      newModifier = window.innerWidth * 0.22;
    }
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      modifierValue: newModifier,
    });
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("resize", this.resizeHandler);
  }

  render() {
    window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("resize", this.resizeHandler);

    const meta = {
      title: "PLAYBOXGAMES: Play free online games",
      description:
        "PlayBoxGames.org is an online platform where you can PLAY GAMES FOR FREE and learn to master them with our predefined strategies.",
      canonical: "https://Playboxgames.org/",
      meta: {
        charset: "utf-8",
        name: {
          keywords: "Playboxgames,Play box,games, play box games",
        },
      },
    };

    return (
      <Aux>
        <DocumentMeta {...meta}>
          <div className={classes.Head + " " +(this.state.scrolled ? classes.scrollHeader : null)}>
            <img
              alt="PlayBox Logo"
              src={LogoDark}
              className={
                classes.Logo +
                " " +
                (this.state.scrolled ? classes.scrollLogo : null)
              }
              style={{
                transform: this.state.scrolled
                  ? "translateX(-" +
                    (this.state.width - this.state.modifierValue) / 2 +
                    "px)"
                  : null,
              }}
            />
          </div>
          <div className={classes.Bottom}>
            <div className={classes.Main} style={{padding: this.state.height >= 1024 ? "300px 100px 50px 100px" : null,}} >
              {" "}
              {/*this padding is for ipad pro*/}
              <Link to="/PlayTicTacToe">
                <Game key="1" id="1" ImgSrc={ttt} Name="TicTacToe"></Game>
              </Link>
              <Link to="/PlayDots-and-boxes">
                <Game key="2" id="2" ImgSrc={DAB} Name="Dots And Boxes" ></Game>
              </Link>
              <Link to="/PlaySnakeGame">
                <Game key="3" id="3" ImgSrc={Snake} Name="Snake"></Game>
              </Link>
              <Link to="/Play2048">
                <Game key="4" id="4" ImgSrc={TZFE} Name="2048"></Game>
              </Link>
              <Link to="/PlayUltimateTicTacToe">
                <Game key="5" id="5" ImgSrc={uttt} Name="Ultimate TicTacToe"></Game>
              </Link>
              <Link to="/PlaySim">
                <Game key="6" id="6" ImgSrc={sim} Name="SIM"></Game>
              </Link>
            </div>
            <Footer />
          </div>
        </DocumentMeta>
      </Aux>
    );
  }
}

export default Home;
